import { CHCPromo } from "./promo.component.js";
customElements.define("chc-promo", CHCPromo);
export {
  CHCPromo
};
//# sourceMappingURL=promo.js.map
